<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="6">
                        <el-col :span="24">
                            <el-form-item label="时间">
                                <el-time-picker
                                        is-range
                                        v-model="value1"
                                        range-separator="至"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        placeholder="选择时间范围"
                                        @change="handleEmptyClassroom()">
                                </el-time-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="教室名">
                                <el-select v-model="name"
                                           remote
                                           clearable
                                           @change="handleEmptyClassroom()"
                                           placeholder="请选择教室名">
                                    <el-option
                                            v-for="item in $parentInfo.Dialog_ChooseFreeClassroom.classroom_names"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="教室号">
                                <el-select v-model="classroom_num"
                                           remote
                                           clearable
                                           @change="handleEmptyClassroom()"
                                           placeholder="请选择教室">
                                    <el-option
                                            v-for="item in $parentInfo.Dialog_ChooseFreeClassroom.classroom_nums"
                                            :key="item.id"
                                            :label="item.classroom_num"
                                            :value="item.classroom_num">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-0">
            <div class="m-portlet__body" v-loading="$parentInfo.Dialog_ChooseFreeClassroom.loading">
                <el-table
                        :data="$parentInfo.Dialog_ChooseFreeClassroom.classrooms"
                        height="300px"
                        style="width: 100%"
                        size="middle">
                    <el-table-column prop="id" label="ID" align="center"></el-table-column>
                    <el-table-column prop="name" label="名字" align="center"></el-table-column>
                    <el-table-column prop="classroom_num" label="教室号" align="center"></el-table-column>
                    <el-table-column prop="student_num" label="学生数" align="center"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ChooseFreeClassroom",
        data() {
            return {
                value1: [new Date(2020, 1, 1, 8, 0), new Date(2020, 1, 1, 23, 59)],
                name:'',
                classroom_num:'',
                classroom_names:[],
                classroom_nums:[],
            }
        },
        mounted() {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleEmptyClassroom()
            this.handleClassroomFields()
        },
        methods: {
            handleEmptyClassroom(){
                this.$parentInfo.Dialog_ChooseFreeClassroom.loading=true
                this.$wApi.send(this.$parentInfo.path, 'choose_empty_classroom', {
                    'date': this.$parentInfo.filter.date,
                    'section_id': this.$parentInfo.filter.section_id,
                    'start_time':this.$moment(this.value1[0]).format('HH:mm'),
                    'end_time':this.$moment(this.value1[1]).format('HH:mm'),
                    'name':this.name,
                    'classroom_num':this.classroom_num,
                });
            },
            handleClassroomFields(){
                this.$wApi.send(this.$parentInfo.path, 'get_classroom_fields', {
                    'section_id': this.$parentInfo.filter.section_id,
                });
            }
        }
    }
</script>

<style scoped>

</style>